import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Container } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../../services/configs";
import { stubFalse } from "lodash";
import ActiveIcon from "../../../assets/icons/active-icon.svg";
import InactiveIcon from "../../../assets/icons/inactive-icon.svg";
import PausedIcon from "../../../assets/icons/paused-icon.svg";
import Active from "../../../assets/icons/active.svg";
import Inactive from "../../../assets/icons/inactive.svg";
import Paused from "../../../assets/icons/paused.svg";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import useResizer from "./../../../services/useResizer";
import fetcher from "../../../api/swr_fetcher";

function createData(
  withdrawlFee,
  minimumWithdrawlFee,
  MinimumDeposit,
  Confirmations,
  withdrawStatus
) {
  return {
    withdrawlFee,
    minimumWithdrawlFee,
    MinimumDeposit,
    Confirmations,
    withdrawStatus,
  };
}

const iconsPath = "./../../../assets/feepageIcons/";
const temp = "BTC.svg";

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
];

export default function FeeTable() {
  const isMobile = useResizer();
  const classes = useStyles();

  const [coinsList, setCoinsList] = useState([]);
  const [searchCoin, setSearchCoin] = useState("");

  const sortFunction = (a, b) => {
    var aWithdrawPriority =
      a.withdrawStatus == "ACTIVE" ? 4 : a.withdrawStatus == "PAUSED" ? 2 : 0;
    var aDepositPriority =
      a.depositStatus == "ACTIVE" ? 4 : a.depositStatus == "PAUSED" ? 1 : 0;
    var bWithdrawPriority =
      b.withdrawStatus == "ACTIVE" ? 4 : b.withdrawStatus == "PAUSED" ? 2 : 0;
    var bDepositPriority =
      b.depositStatus == "ACTIVE" ? 4 : b.depositStatus == "PAUSED" ? 1 : 0;

    var aPriority = aWithdrawPriority + aDepositPriority;
    var bPriority = bWithdrawPriority + bDepositPriority;
    // if(aPriority == bPriority){
    //   if(a.depositAllowed > b.depositAllowed){
    //     return -1;
    //   }else{
    //     return 1;
    //   }
    // }
    return bPriority - aPriority;
  };

  const handleChange = (event) => {
    setSearchCoin(event.target.value);
  };

  useEffect(() => {
    fetcher(`/v1/coinConfig`).then((data) => {
      data = data.filter(
        (row) => !(row.coinId == "AE" || row.coinId == "NPXS")
      );
      data = data.sort((a, b) => {
        return sortFunction(a, b);
      });
      setCoinsList(data);
    });
  }, []);

  return (
    <div className="container-bt">
      <div className={!isMobile ? classes.flexRow : classes.flexColumn}>
        <div>
          <div
            style={{
              marginLeft: !isMobile ? "50px" : "10px",
              fontWeight: "bolder",
              fontSize: "28px",
              marginBottom: "5px",
            }}
          >
            Crypto Transfer Fees
            <p className="text-base mt-2 mb-4 font-normal">
              Blockchain Fees for sending crypto to other wallets/exchanges.
            </p>
          </div>
        </div>
        <div
          style={{
            marginRight: !isMobile ? "50px" : "0px",
            marginLeft: !isMobile ? "0px" : "10px",
            marginBottom: "10px",
            height: "32px",
            width: "250px",
            display: "flex",
            border: "thin solid #3AC4AB",
            boxShadow: "inset 1px 2px 5px #3AC4AB",
            borderRadius: "5px",
          }}
        >
          <InputBase
            onChange={handleChange}
            fullWidth="false"
            className={`${classes.input}`}
            style={{ paddingLeft: "15px" }}
            placeholder="Search"
            inputProps={{ "aria-label": "search google maps" }}
          />
          {/* <div style={{backgroundColor: "#3AC4AB", width: "2.5em", height:"100%"}}><SearchIcon fontSize="large"/></div> */}
        </div>
      </div>
      <Container
        maxWidth="lg"
        style={{
          // overflowX: "scroll",
          marginBottom: "100px",
          borderRadius: "20px",
        }}
      >
        {/* <TableContainer component={Paper} className={classes.paper}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell align="right">Asset</TableCell>
              <TableCell align="right">Withdrawl fee</TableCell>
              <TableCell align="right">Minimum withdrawl Amount</TableCell>
              <TableCell align="right">Minimum Deposit</TableCell>
              <TableCell align="right">Confirmations</TableCell>
              <TableCell align="right">Withdrawl Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.caloriewithdrawStatus}</TableCell>
                <TableCell align="right">{row.withdrawStatus}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}

        <table className={classes.table}>
          <thead className={classes.tableHeader}>
            <th className={classes.headerText} style={{ width: "223px" }}>
              <Typography>Asset</Typography>
            </th>
            <th className={classes.headerText}>
              <Typography className="px-3 w-max md:w-auto">
                Blockchain Fee
              </Typography>
            </th>
            <th className={`${classes.headerText}`}>
              <Typography className="px-3 w-max md:w-auto">
                Send Minimum
              </Typography>
            </th>
            <th className={classes.headerText}>
              <Typography className="px-3 w-max md:w-auto">
                Receive Minimum
              </Typography>
            </th>
            <th className={classes.headerText}>
              <Typography className="px-3 w-max md:w-auto">
                Confirmations
              </Typography>
            </th>
            {/* <th className={classes.headerText}>
              <Typography>Withdraw Status</Typography>
            </th>
            <th className={classes.headerText}>
              <Typography>Deposit Status</Typography>
            </th> */}
          </thead>
          {/* filter((row) => {(row.coinName.includes(searchCoin) || row.coinId.includes(searchCoin))}). */}
          {coinsList
            .filter((row) => {
              return (
                row.coinName.toLowerCase().indexOf(searchCoin.toLowerCase()) !==
                  -1 ||
                row.coinId.toLowerCase().indexOf(searchCoin.toLowerCase()) !==
                  -1
              );
            })
            .map((row) => (
              <tr className={classes.flexContainer}>
                <td className={classes.logoAndText}>
                  <div style={{ paddingLeft: "10px", paddingRight: "8px" }}>
                    {/* <img
                      src={
                        process.env.PUBLIC_URL +
                        "/static/" +
                        row.coinId +
                        ".svg"
                      }
                      width={23}
                      height={23}
                    /> */}
                    <img src={row.inactiveIconUrl} width={23}></img>
                  </div>
                  <div>
                    {row.coinName} ({row.coinId})
                  </div>
                </td>
                <td>{row.withdrawFee}</td>
                <td>{row.minAmountWithdraw}</td>
                <td>{row.minAmountDeposit}</td>
                <td>{row.confirmations}</td>
                {/* <td>
                  {row.withdrawStatus != "INACTIVE" ? (
                    row.withdrawStatus != "ACTIVE" ? (
                      <div className={classes.statusIcons}>
                        <img
                          src={Paused}
                          width={14}
                          height={14}
                          alt="Paused"
                          style={{ marginBottom: "4px" }}
                        />
                        Paused
                      </div>
                    ) : (
                      <div className={classes.statusIcons}>
                        <img
                          src={Active}
                          width={14}
                          height={14}
                          alt="Active"
                          style={{ marginBottom: "4px" }}
                        />
                        Active
                      </div>
                    )
                  ) : (
                    <div className={classes.statusIcons}>
                      <img
                        src={Inactive}
                        width={14}
                        height={14}
                        alt="Inactive"
                        style={{ marginBottom: "4px" }}
                      />
                      Inactive
                    </div>
                  )}
                </td> */}
                {/* <td>
                  {row.depositStatus != "INACTIVE" ? (
                    row.depositStatus != "ACTIVE" ? (
                      <div className={classes.statusIcons}>
                        <img
                          src={Paused}
                          width={14}
                          height={14}
                          alt="Paused"
                          style={{ marginBottom: "4px" }}
                        />
                        Paused
                      </div>
                    ) : (
                      <div className={classes.statusIcons}>
                        <img
                          src={Active}
                          width={14}
                          height={14}
                          alt="Active"
                          style={{ marginBottom: "4px" }}
                        />
                        Active
                      </div>
                    )
                  ) : (
                    <div className={classes.statusIcons}>
                      <img
                        src={Inactive}
                        width={14}
                        height={14}
                        alt="Inactive"
                        style={{ marginBottom: "4px" }}
                      />
                      Inactive
                    </div>
                  )}
                </td> */}
              </tr>
            ))}
        </table>
      </Container>
    </div>
  );
}

const useStyles = makeStyles({
  // paper: {
  //   borderRadius: "15px",
  //   overflow: "hidden",
  // },
  // table: {
  //   borderRadius: "15px",
  //   overflow: "hidden",
  //   color: "white",
  //   minWidth: 650,
  //   backgroundColor: "#171717",
  // },
  // tableHead: {
  //   backgroundColor: "#252933",
  // },
  table: {
    background: "#1D212D",
    height: "60%",
    width: "100%",
    color: "white",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "10px 20px 30px rgba(5, 15, 26, 0.5)",
  },
  tableHeader: {
    background: "#252933",
    textAlign: "center",
    height: "50px",
  },
  topText: {
    textAlign: "center",
    paddingBottom: "20px",
  },
  headerText: {
    height: "50px",
    textAlign: "center",
    // marginTop: "0px",
    // paddingTop: "0px"
  },
  button: {
    color: "#fff",
    borderRadius: "15px",
  },
  flexContainer: {
    textAlign: "center",
    height: "50px",
    fontFamily: ['"Gordita"', "sans-serif"].join(","),
  },
  logoAndText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
  flexRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  statusIcons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "10px",
  },
});
